import React, { memo } from 'react';
import { Blok } from '../../interfaces/Blok.interface';
import { StoryblokNode } from '../../interfaces/StoryblokNode.interface';
import { withBlokWrapper } from '../BlokWrapper/BlokWrapper';
import { Theme } from '../../interfaces/enums/Theme.enum';
import { storyblokEditable } from 'gatsby-source-storyblok';
import Container from '../Utils/Container/Container';
import Grid from '../Utils/Grid/Grid';
import Col from '../Utils/Col/Col';
import PartnersBlokCard from './PartnersBlokCard';
import { v4 as uuidv4 } from 'uuid';

interface PartnersBlokBlokProps extends Blok {
  pages_to_show: StoryblokNode[];
}

interface PartnersBlokProps {
  blok: PartnersBlokBlokProps;
}

const PartnersBlok: React.FC<PartnersBlokProps> = ({ blok }) => {
  const { pages_to_show } = blok;

  return (
    <section {...storyblokEditable(blok)}>
      <Container>
        <div className="py-20 lg:py-28">
          <Grid gapY="gap-y-16">
            {pages_to_show.map((pageToShow: StoryblokNode) => (
              <Col key={uuidv4()} span={{ lg: 4 }}>
                <PartnersBlokCard
                  url={pageToShow.full_slug}
                  image={pageToShow.content.preview_card_image}
                  title={pageToShow.content.preview_card_heading}
                  body={pageToShow.content.preview_card_body}
                />
              </Col>
            ))}
          </Grid>
        </div>
      </Container>
    </section>
  );
};

export default memo(withBlokWrapper(PartnersBlok));
